<template>
  <modal
    v-slot="{ data: { unavailableItems, invalidDaypartItems } }"
    name="unavailableItems"
    modal-style="compact"
  >
    <unavailable-items
      :unavailable-items="unavailableItems"
      :invalid-daypart-items="invalidDaypartItems"
    />
  </modal>
</template>


<script>
  import UnavailableItems from './unavailable-items/index.vue';


  export default {
    name: 'UnavailableItemsModal',

    components: {
      UnavailableItems
    }
  };
</script>
